<pannel [title]="'Consignes liées au risque électrique (PV)'" [expandable]="true">
	<!-- Obligations -->
	<div>
		<h4><b>Obligations pour l’EE</b></h4>
		<ul>
			<li *ngFor="let item of traductionsObligations">
				<ng-container *ngIf="item.presentation === 'TICK' || item.presentation === 'CROSS'">
					<span>{{ item.fr }}</span>
					<img src="assets/images/pa/{{item.imagePath}}" *ngIf="item.imagePath" class="{{item.imagePosition}} {{item.imageSize}}">
				</ng-container>

				<ng-container *ngIf="item.presentation === 'CHECKBOX'">
					<label>
						<input type="checkbox" [(ngModel)]="item.checked" />
						{{ item.fr }}
					</label>
				</ng-container>
			</li>
		</ul>
	</div>

	<!-- Interdictions -->
	<div>
		<h4><b>Interdictions pour l’EE</b></h4>
		<ul>
			<li *ngFor="let item of traductionsInterdictions">
				<ng-container *ngIf="item.presentation === 'TICK' || item.presentation === 'CROSS'">
					<span>{{ item.fr }}</span>
				</ng-container>

				<ng-container *ngIf="item.presentation === 'CHECKBOX'">
					<label>
						<input type="checkbox" [(ngModel)]="item.checked" />
						{{ item.fr }}
					</label>
				</ng-container>
			</li>
		</ul>
	</div>
</pannel>

<document-pa-step-actions
	[documentPaButtons]="actionButtons"
	(onButtonPressed)="performAction($event)">
</document-pa-step-actions>
